import React from "react";
import { Spin } from "antd";

export const Loader = ({ spaceSize, spinSize }) => {
  return (
    <div style={{ textAlign: "center", marginTop: "50px" }} size={spaceSize || "middle"}>
      <Spin size={spinSize || "large"} />
    </div>
  );
};

export default Loader;
